<template>
<div class="date-wrapper">
  <datepicker input-class="date-picker-box"
              :placeholder="placeHolder"
              v-model="dateValue"
              :full-month-name="true"
              format="yyyy년 MM월 dd일"/>
</div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';

export default {
  name: 'LayoutDatePicker',
  components: {
    Datepicker,
  },
  props: {
    placeHolder: String,
    value: [String, Number],
    callback: Function,
  },
  watch: {
    dateValue(value) {
      this.$emit('input', value);
    },
  },
  data() {
    return {
      dateValue: this.value || null,
    };
  },
};
</script>

<style lang="scss" scoped>
.date-wrapper {
  width: auto;
  height: auto;
}
</style>

<style lang="scss">
.date-picker-box {
  width: 500px;
  height: 40px;
  outline: none;

  border: rgba(180, 180, 180, 0.4) 1px solid;
  border-radius: 5px;

  padding-left: 15px;

  margin-top: 10px;
  margin-bottom: 10px;
}

.date-picker-box:hover {
  border: rgba(180, 180, 180, 0.8) 1px solid;
}

.date-picker-box:focus {
  border: rgba(100, 200, 255, 0.8) 1px solid;
  box-shadow: rgba(0, 0, 0, 0.1) 1px 1px 5px 1px;
}
</style>



// WEBPACK FOOTER //
// src/spa/components/LayoutDatePicker.vue